import React, { useState } from "react";
import { InputGroup, Form, Input, Button } from "reactstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const App = () => {
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("wa");

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`https://otp.nanyang.sch.id/${type}`, {
        otp: Math.floor(Math.random() * 90000) + 10000,
        hp: phone,
        app: "TESTING",
      })
      .then((res) => {
        toast.success(res.data.message ?? "Code Sent");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      })
      .then(() => {
        setPhone("");
      });
  };

  return (
    <>
      <Form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          width: "inherit",
          height: "inherit",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <InputGroup style={{ width: "25%", paddingBottom: "5%" }}>
          <Input
            id="nohp"
            value={phone}
            placeholder="08xxxxxxxxx"
            onChange={(e) => {
              e.preventDefault();
              setPhone(e.target.value);
            }}
          />
          <Input
            id="exampleSelect"
            name="select"
            type="select"
            value={type}
            onChange={(e) => {
              e.preventDefault();
              setType(e.target.value);
            }}
          >
            <option value="sms">SMS</option>
            <option value="wa">WA</option>
          </Input>
        </InputGroup>
        <Button color="dark" type="submit" style={{ width: "10%" }}>
          Kirim OTP
        </Button>
      </Form>
      <ToastContainer theme="dark" autoClose={500} hideProgressBar={true} />
    </>
  );
};

export default App;
